import React from 'react';
import { Box, Typography } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import styles from './MeterChangeHeader.styles';

export default function MeterChangeHeader({ title = 'Meter Changes' }) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <SwapHorizIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>
    </Box>
  );
}
